// src/redux/content/ContentSlice.js
import { createSlice } from "@reduxjs/toolkit";

const contentSlice = createSlice({
  name: "content",
  initialState: {
    loading: false,
    selectedContent: "",
    contentData: "",
    error: null,
  },
  reducers: {
    fetchContentRequest: (state, action) => {
      state.loading = true;
      state.selectedContent = action.payload;
      state.error = null;
    },
    fetchContentSuccess: (state, action) => {
      state.loading = false;
      state.contentData = action.payload;
    },
    fetchContentFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    saveContentRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    saveContentSuccess: (state) => {
      state.loading = false;
    },
    saveContentFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchContentRequest,
  fetchContentSuccess,
  fetchContentFailure,
  saveContentRequest,
  saveContentSuccess,
  saveContentFailure,
} = contentSlice.actions;

export default contentSlice.reducer;
